import { Renderer2 } from '@angular/core';
import { InputEditorBase } from 'app/slick-grid/models/input-editor-base';

export class TextEditor<T extends Slick.SlickData> extends InputEditorBase<T> {
    constructor(protected readonly renderer: Renderer2,
                args: Slick.Editors.EditorOptions<T>,
                validator?: (value: string, item: T, editor: TextEditor<T>) => Slick.ValidateResults,
                customKeyDownHandler?: (event: KeyboardEvent, item: T, editor: TextEditor<T>) => boolean) {
        super(renderer, args, validator, customKeyDownHandler);

        this.input.type = 'text';
    }

    isValueChanged(): boolean {
        return super.isValueChanged() || this.input.value !== this.getHtmlFormattedValue(this.args.item);
    }

    applyValue = (item: T, state: string): void => {
        item[this.args.column.field] = state;
    }

    protected getHtmlFormattedValue = (item: T): string => {
        return item[this.args.column.field];
    }

    public readonly clone = (): TextEditor<T> => {
        return new TextEditor<T>(this.renderer, this.args, this.validator, this.customKeyDownHandler)
    }
}
//export class SlickGridNumericEditor<T extends Slick.SlickData> {
//    constructor(private readonly args: Slick.Editors.EditorOptions<T>, private readonly decimalPlaces: number, private readonly validator?: (item: T) => Slick.ValidateResults) {
//        this.input = document.createElement('input');
//        this.input.type = 'number';
//        if (decimalPlaces > 0)
//            this.input.step = `${1 / Math.pow(10, Math.min(decimalPlaces, SlickGridFormatters.maxAllowedDecimalPlaces))}`;
//        this.args.container.appendChild(this.input);
//    }

//    private readonly input: HTMLInputElement;

//    destroy = (): void => {
//        this.input.remove();
//    }

//    focus = (): void => {
//        this.input.focus();
//    }

//    isValueChanged = (): boolean => {
//        return this.input.value !== this.getHtmlFormattedValue(this.args.item);
//    }

//    serializeValue = () => {
//        return this.input.value;
//    }

//    loadValue = (item: T): void => {
//        this.input.value = this.getHtmlFormattedValue(item);
//    }

//    applyValue = (item: T, state: string): void => {
//        item[this.args.column.field] = +state; //numeral(state).value;
//    }

//    validate = (): Slick.ValidateResults => {
//        return this.validator ? this.validator(this.args.item) : { valid: true, msg: null };
//    }

//    private getHtmlFormattedValue = (item: T): string => {
//        const number = numeral(item[this.args.column.field]);
//        const currentLocale = numeral.locale();
//        try {
//            numeral.locale('en');
//            return number.format(SlickGridFormatters.getNumeralFormatString(this.decimalPlaces));
//        } finally {
//            numeral.locale(currentLocale);
//        }
//    }
//}



// WEBPACK FOOTER //
// ./src/app/slick-grid/models/text-editor.ts